<script>
  import {HorizontalBar, mixins} from 'vue-chartjs'
  // import the component - chart you need

  // Extend it
  export default {
    extends: HorizontalBar,
    //mixins: [mixins.reactiveProp],
    props: ['behaviorName','behaviorColor','submissionData','behaviorID',"category","duration","durationDaily","durationMonthly","durationYearly"],
    //props: ['chartdata', 'options'],
    data() {
        var _this = this;
        return {
            datacollection: {
                labels: this.behaviorName,
                datasets: [
                    {
                        label: 'Data One',
                        backgroundColor: this.behaviorColor,
                        dataPointWidth: 10,
                        data: this.submissionData,
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: 'bottom'
                },
                dataPointWidth: 10,
                scales: {
                    xAxes: [{
                        ticks: {
                            autoSkip: true,
                            maxRotation: 90,
                            minRotation: 90,
                        }
                    }]
                },
                onClick: function(evt,arr) {
                    var selectedLabelColumn;
                    var selectedLabelColumnTitle;
                    this.getElementsAtEventForMode(evt, "y", 1).forEach(function(item) { selectedLabelColumn = item._index; selectedLabelColumnTitle = item['_model']['label']; 
                    console.log("46 item"); console.log(item['_model']['label']) });
                    // alert("Column " + selectedLabelColumn + " was selected");
                    // alert("Column " + selectedLabelColumnTitle + " was selected");

                    try{
                        var label = arr[0]['_model'].label  //this line is purely to throw error for empty bar
                        _this.graphClickEvent(evt,arr);
                    }catch(err){
                        _this.viewBarDetails(selectedLabelColumn,selectedLabelColumnTitle)
                    }
            
                }
            }
        }
    },
    methods: {
        graphClickEvent(evt,arr){
            var label = arr[0]['_model'].label
            var index = arr[0]['_index']
            console.log("64 arr[0]")
            console.log(arr[0])

            console.log("65 this.behaviorName: " + this.behaviorName)
            console.log("65 label: " + label)
            console.log("65 index: " + index)
            console.log("65 this.behaviorID: " + this.behaviorID)
            console.log("65 this.category: " + this.category)
            console.log("65 this.duration: " + this.duration)
            console.log("65 this.durationDaily: " + this.durationDaily)
            console.log("65 this.durationMonthly: " + this.durationMonthly)
            console.log("65 this.durationYearly: " + this.durationYearly)
            
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_ID',this.behaviorID[index])
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_NAME',this.behaviorName[index])
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_CATEGORY',this.category)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION',this.duration)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION_DAILY',this.durationDaily)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION_MONTHLY',this.durationMonthly)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION_YEARLY',this.durationYearly)
            localStorage.setItem('VIEW_SUBMISSIONS_BEHAVIOR_ID',this.behaviorID[index])
            localStorage.setItem('VIEW_SUBMISSIONS_BEHAVIOR_NAME',this.behaviorName[index])
            localStorage.setItem('VIEW_SUBMISSIONS_CATEGORY',this.category)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION',this.duration)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION_DAILY',this.durationDaily)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION_MONTHLY',this.durationMonthly)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION_YEARLY',this.durationYearly)

            // this.$router.push({
            //     name: "SubmissionDetails"
            // });
        },
        viewBarDetails(index,label){
            console.log("88 this.behaviorName[index]: " + this.behaviorName[index])
            console.log("88 label: " + label)
            console.log("88 index: " + index)
            console.log("88 this.behaviorID[index]: " + this.behaviorID[index])
            console.log("88 this.category: " + this.category)
            console.log("88 this.duration: " + this.duration)
            console.log("88 this.durationDaily: " + this.durationDaily)
            console.log("88 this.durationMonthly: " + this.durationMonthly)
            console.log("88 this.durationYearly: " + this.durationYearly)

            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_ID',this.behaviorID[index])
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_NAME',this.behaviorName[index])
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_CATEGORY',this.category)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION',this.duration)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION_DAILY',this.durationDaily)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION_MONTHLY',this.durationMonthly)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION_YEARLY',this.durationYearly)
            localStorage.setItem('VIEW_SUBMISSIONS_BEHAVIOR_ID',this.behaviorID[index])
            localStorage.setItem('VIEW_SUBMISSIONS_BEHAVIOR_NAME',this.behaviorName[index])
            localStorage.setItem('VIEW_SUBMISSIONS_CATEGORY',this.category)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION',this.duration)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION_DAILY',this.durationDaily)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION_MONTHLY',this.durationMonthly)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION_YEARLY',this.durationYearly)

            // this.$router.push({
            //     name: "SubmissionDetails"
            // });
        }
    },
    mounted () {
      // Overwriting base render method with actual data and options
      this.renderChart(this.datacollection, this.options)
      this.$data._chart.destroy(); //we destroy to try clearing the cached chart data inside user's browser
      this.renderChart(this.datacollection, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Charts/HorizontalBarChart.vue